const breakpoints = {
  s: '420px',
  m: '768px',
  l: '1280px',
  xl: '1440px'
};

export { breakpoints };
